import MfSearchSelect from './src/mf-search-select'

MfSearchSelect.install = function (Vue) {
  Vue.component(MfSearchSelect.name, MfSearchSelect)
}

export default MfSearchSelect
